import React, { useEffect } from "react";
import "./InterestPage.css";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

const InterestPage = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 }); //might need to be AOS
  }, []);
  return (
    <div className="container">
      <div className="row">
        <div data-aos="flip-up" className="col">
          <h1>
            What is The <i>Dunning-Kruger Effect</i>?
          </h1>
        </div>
      </div>
      <div className="row row-spacing-big">
        <div data-aos="fade-in" className="col-8 md-3">
          <div className="">
            <p className="paragraph1">
              The Dunning-Kruger effect effect occurs when a person’s lack of
              knowledge and skills in a certain area cause them to overestimate
              their own competence. By contrast, this effect also causes those
              who excel in a given area to think the task is simple for
              everyone, and underestimate their relative abilities as well.
            </p>
            <br />
            <p className="paragraph1">
              As a result of the Dunning-Kruger effect, you may not know what
              you’re good at, because you assume that what comes easily to you
              also comes easily to everyone else. You are therefore robbed of
              the ability to spot your own specialties and talents.
            </p>
            <br />
          </div>
          <div>
            <small id="emailHelp" class="form-text text-muted">
              <a
                href="https://thedecisionlab.com/biases/dunning-kruger-effect"
                target="blank">
                source
              </a>
            </small>
          </div>
        </div>
        <div data-aos="fade-in" className="col">
          <img
            className="imgdunning"
            src="https://64.media.tumblr.com/e09aea043511369dffb1705a6035549e/tumblr_inline_pk0r28PZJT1ruijaf_500.jpg"
            alt="image of Mr.Dunning"></img>
        </div>
      </div>
      <div className="row row-spacing-big">
        <div className="col">
          <img src="https://media3.giphy.com/media/l3nWhI38IWDofyDrW/giphy.gif?cid=790b7611298d33f634f230fe293bdd35311ea5a41bc076eb&rid=giphy.gif&ct=g"></img>
        </div>
        <div className="col">
          <h3 style={{ direction: "rtl" }}>My Interest</h3>
          <br />
          <p className="paragraph1">
            I had taught a friend at school how to code the basics of{" "}
            <code>python</code>, and it was my goal to see if that could start
            their coding journey. Instead, they ended up mentioning the fact
            that they could code at any given opportunity. I found this a bit
            comical since they literally just learned how to make a while loop.
            Anyways, when I stumbled across the Dunning-Kruger Effect, I found a
            lot of truth in it. Here is my interpretation of the graph.
          </p>
        </div>
      </div>
      <div className="row row-spacing-big">
        <div className="col">
          <br />
          <div class="accordion" id="accordionExample">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button
                    class="btn btn-link paragraph1 btn-block text-left"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne">
                    Uninformed
                  </button>
                </h2>
              </div>

              <div
                id="collapseOne"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#accordionExample">
                <div class="card-body">
                  You're uninformed about a particular subject
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button
                    class="btn btn-link paragraph1 btn-block text-left"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseNine"
                    aria-expanded="true"
                    aria-controls="collapseNine">
                    Peak of 'Mount Stupid'
                  </button>
                </h2>
              </div>
              <div
                id="collapseNine"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#accordionExample">
                <div class="card-body">
                  This stage generally happens when you learn just the basics
                  about a subject, but your confidence goes way up due to your
                  lack of knowledge. Similar to being able to print 'Hello
                  world' in your console, and then proceeding to call yourself a
                  'programmer'.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button
                    class="btn btn-link paragraph1 btn-block text-left"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwen"
                    aria-expanded="true"
                    aria-controls="collapseTwen">
                    Valley of Despair
                  </button>
                </h2>
              </div>

              <div
                id="collapseTwen"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#accordionExample">
                <div class="card-body">
                  If you then plan to pursue this subject, you will soon find
                  yourself in the dreaded, 'Valley of Despair'. When you first
                  start craving your path, you will get flooded with tons of
                  information that can be overwhelming.{" "}
                  <b>Knowing how much you don't know</b> causes many to end
                  their journey too soon; which is why when you inventable find
                  yourself in the Valley of Despair, take a deep breath and
                  tackle each obstacle one at a time.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                  <button
                    class="btn btn-link paragraph1 btn-block text-left collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo">
                    Slope of Enlightment
                  </button>
                </h2>
              </div>
              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordionExample">
                <div class="card-body">
                  This is the grinding stage. This stage will most likely take
                  many years and will be a slow gradual process. Slowly but
                  surely you work on your path while your competence increases;
                  many developers are in this stage so go along the ride
                  carefree. You will gain knowledge, make friends, and change
                  your lifestyle integrating you, and your profession.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingThree">
                <h2 class="mb-0">
                  <button
                    class="btn btn-link paragraph1 btn-block text-left collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree">
                    Guru
                  </button>
                </h2>
              </div>
              <div
                id="collapseThree"
                class="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordionExample">
                <div class="card-body">
                  On the long journey to becoming a Guru; You found your path
                  and run with it, practice, practice, practice... You also
                  learned to make yourself uncomfortable by going into unknown
                  regions head-on and becoming comfortable with those as well.
                  In this period, your competence and confidence increase,
                  almost at an exponential rate until you've reached the
                  confidence you had coming in (peak of mount stupid) except you
                  have the skill and knowledge to bakc it up... you have become
                  a master
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestPage;
